const NAVBAR_WHITE = 'navbar-white';
const NAVBAR_TRANSPARENT = 'navbar-transparent';
const NAVBAR_MOBILE = 'navbar-mobile';
const NAVBAR_HOMEPAGE = 'navbar-homepage';
export {NAVBAR_WHITE, NAVBAR_TRANSPARENT, NAVBAR_MOBILE, NAVBAR_HOMEPAGE};
